export const COMPANY = {
  name: "Goyam Ingredients",
  tagline: "Sourcing the world's finest cosmetic & BPC raw materials.",
  phone: "+91 91677 09093",
  phoneHref: "tel:+919167709093",
  email: "jhanvishah@goyamingredients.com",
  emailHref: "mailto:jhanvishah@goyamingredients.com",
  address:
    "41, Bajaj Bhavan, 4th Floor, Barrister Rajni Patel Marg, Nariman Point, Mumbai, Maharashtra 400021",
  addressShort: "Mumbai, India",
  hours: "Mon – Sat · 9:30 AM – 6:30 PM IST",
  domain: "goyamingredients.com",
  logoUrl:
    "https://customer-assets.emergentagent.com/job_bpc-imports/artifacts/xyfz6vtg_2.png",
};

export const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/products", label: "Products" },
  { to: "/services", label: "Services" },
  { to: "/contact", label: "Contact" },
];

export const MARQUEE_ITEMS = [
  "Emulsifiers",
  "Surfactants",
  "Actives",
  "Preservatives",
  "Emollients",
  "Botanical Extracts",
  "Colorants",
  "Fragrances",
  "Humectants",
  "Rheology Modifiers",
];

export const INDUSTRIES = [
  "Skincare",
  "Haircare",
  "Color Cosmetics",
  "Oral Care",
  "Fragrance Houses",
  "Personal Care",
  "Baby Care",
  "Men's Grooming",
];
